import React, { PureComponent } from 'react'

class Branch extends PureComponent {
  selectHandler = (event) => {
    event.preventDefault()
    const { selectHandler, branch } = this.props
    selectHandler(branch)
  }

  render() {
    const { branch } = this.props
    return (
      <div className="atp-grid-2-1 atp-grid-m-1-1 atp-offset-m-1-0">
        <div className="atp-locations__container">
          <div className="atp-locations__img" style={{ backgroundImage: `url(${branch.get('pictureUrl')})` }}></div>
          <div className="atp-locations__adress">
            <h2 className="atp-h2">{branch.get('name')}</h2>
            <span>
              {branch.get('street')}
              <br />
              {branch.get('zip')} {branch.get('city')}
            </span>
            <button
              onClick={this.selectHandler}
              className="atp-btn atp-btn--right-icon atp-btn--icon-add atp-margin-top-xs">
              Auswählen »
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default Branch
